import style from './list-keyfigures.scss';
import $ from 'jquery';
import 'slick-carousel';
import breakpoints from 'DesignSystem/responsive/breakpoints';
import listKeys from 'Assets/js/list-key-behavior';

const script = () => {
  const cssClass: string = 'ListKeyfigures';
  const target: string = `.${cssClass}-list`;
  const targets: any = document.querySelectorAll(target);

  listKeys({
    cssClass: `.${cssClass}`,
    titleClass: '.TeaserKeyfigure-highlight',
  });

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }

    // init element
    elt.dataset[`init${cssClass}`] = true;
    $(elt).slick({
      dots: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: breakpoints.params.desktop,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: breakpoints.params.tablet,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
};

export {
  style,
  script,
};
